import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import axios from 'axios';

import '../../css/SingleScreens/UserProfileEditScreen.css';
import '../../css/InstantScreens/Instant.css';

import { Routes as routes, History as history } from '../../navigation';
import { ValidatorUtils, StringUtils } from '../../utils';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { TitleBar, SingleScreenNavBar, Input, Button, Errors } from  '../../components'

class UserForgotPasswordScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
    }
  }

  renderForgotPasswordSection = () => {

    return   <div className="flex-container" style={{  justifyContent: 'center', alignItems: 'center' }}>
        <div className='instant-sign-up-container flex-container-column' style={{  }}>

          <div className='flex-container-row' style={{ justifyContent: 'space-between', padding: 10, paddingLeft: 15, paddingRight: 15, alignItems: 'center' }}>
            <span className='fas fa-arrow-circle-left instant-back-button'
                  style={{ fontSize: 30 }}
                  onClick={ () => {
                    history.goBack();
                  }} />
            <div className='flex-container-column' style={{ alignItems: 'center' }}>
              <span style={{ fontWeight: 'bold', fontSize: 22 }}>Forgot Password</span>
              <span style={{ width: 170, height: 2, borderRadius: 2, backgroundColor: '#1dc2ff' }}></span>
            </div>
            <span className='fas fa-arrow-circle-left' style={{ fontSize: 30, color: 'white' }}></span>
          </div>

          <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 15 }}>
            <Input placeholder="Enter Account Email"
                   value={this.state.email}
                   className='instant-input-default'
                   style={{  }}
                   onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
                  />
          </div>

          <div className='flex-container-row' style={{ paddingTop: 8, justifyContent: 'center', marginBottom: 15 }}>
            <Button value='Send Email'
                    style={{ paddingRight: 40, paddingLeft: 40 }}
                    loading={this.state.loading}
                    onClick={ () => {
                      if (this.state.email) {
                        this.props.userActions.sendForgotPasswordEmail(this.state.email, this.callback);
                      }
                    }}/>
          </div>

        </div>
      </div>
  }

  render() {
    const user = this.props.user && this.props.user.user ? this.props.user.user : null;
    return (
      <div className="flex-container flex-container-column flex-center-align">
        { this.renderForgotPasswordSection() }
      </div>
    );
  }

  callback = () => {
    NavigationActions.navigateBack()
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserForgotPasswordScreen)
